const _find = require("lodash.find");
/**
 * @private
 */
export class BasicEnum {
    // Dictionary of all enumerated values for all subclasses
    private static _basicValues: Map<any, any> = new Map<any, any>();

    // secret value that is needed in the constructor and prevents the instantiation of enums outside of their classes
    protected static instantiationKey: number = Math.random();

    // instance variables
    private _name: string;

    // getter for instance variables
    public get name(): string {
        return this._name;
    }

    /**
     * Basic enum class from which custom enums can be derived from.
     *
     * <p>
     *     Do not instantiate, this is an abstract class!
     * </p>
     *
     * For correct usage, have a look at some of its subclasses.
     *
     * @param name
     * @param doNotInstantiate
     */
    constructor(name: string, doNotInstantiate: number) {
        if (doNotInstantiate != BasicEnum.instantiationKey) {
            this.throwInstantiationError();
        }

        this._name = name;

        // save in value list for its enum type
        let enumClass: any = (<any>this).constructor;

        if (BasicEnum._basicValues.get(enumClass) == null) {
            BasicEnum._basicValues.set(enumClass, []);
        }
        BasicEnum._basicValues.get(enumClass).push(this);
    }

    /**
     * Standard method to get a certain enum value by one of its properties, to implement property-specific methods in custom enums.
     * @param enumType
     * @param propertyName
     * @param propertyValue
     * @param valueNone
     * @return
     */
    protected static getByProperty(enumType: any, propertyName: string, propertyValue: any, valueNone: BasicEnum): BasicEnum {
        const values: BasicEnum[] = BasicEnum._basicValues.get(enumType);
        return _find(values, [propertyName, propertyValue]) || valueNone;

        //return values.find(item => propertyName in item && item[propertyName] === propertyValue) || valueNone;  //replace lodash completely
    }

    public toString(): string {
        return this.getClassName() + "." + this._name;
    }

    protected getClassName(): string {
        return this.getQualifiedClassName(this).match("[^:]*$")[0];
    }

    protected throwInstantiationError(): void {
        throw new Error("Only instantiate " + this.getClassName() + " within itself!");
    }

    /**
     * this was imported from createjs utilities but why having that dependencies just for this..
     * @param instance
     * @returns {string}
     */
    private getQualifiedClassName(instance: any): string {
        return instance.constructor.name + "";
    }
}
